import { render, staticRenderFns } from "./viewCustomerReturns.vue?vue&type=template&id=1e66b58c&"
import script from "./viewCustomerReturns.vue?vue&type=script&lang=js&"
export * from "./viewCustomerReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports